export let
  responseCreated = "responseCreated",
  reportRanges = [
    {id: 'AllTime', title: "All Time", name: "All Time"},
    {id: 'Last7Days', title: "Last 7 Days", name: "7 Days"},
    {id: 'Last30Days', title: "Last 30 Days", name: "30 Days"},
    {id: 'Last3Months', title: "Last 3 Months", name: "3 Months"},
    {id: 'Last6Months', title: "Last 6 Months", name: "6 Months"},
    {id: 'Last12Months', title: "Last 12 Months", name: "12 Months"},
    {id: 'SpecificDates', title: "Selected Dates", name: "Selected Dates"}
  ],
  ADVANCED_SEARCH_OPTIONS = [].concat([
    {name: "Only Reviews with Responses", parameterName: "responsesFilter", value: "OnlyWith"},
    {name: "Only Reviews without Responses", parameterName: "responsesFilter", value: "OnlyWithout", lastOfType: true},
    {name: "Only Reviews with Notes", parameterName: "notesFilter", value: "OnlyWith"},
    {name: "Only Reviews without Notes", parameterName: "notesFilter", value: "OnlyWithout", lastOfType: true},
    {name: "Only Reviews with Revisions", parameterName: "revisionsFilter", value: "OnlyWith"},
    {name: "Only Reviews without Revisions", parameterName: "revisionsFilter", value: "OnlyWithout", lastOfType: true},
    {name: "Only Reviews with Text", parameterName: "textFilter", value: "OnlyWith"},
    {name: "Only Reviews without Text", parameterName: "textFilter", value: "OnlyWithout", lastOfType: true},
    {name: "Only Reviews with Tags", parameterName: "tagFilter", value: "OnlyWith"},
    {name: "Only Reviews without Tags", parameterName: "tagFilter", value: "OnlyWithout", lastOfType: true},
    {name: "Only Removed Reviews", parameterName: "removedReviewsFilter", value: "OnlyWith"},
    {name: "Only Filtered Reviews", parameterName: "filteredReviewsFilter", value: "OnlyWith", lastOfType: true},
    {name: "Only Reviews with Responding Enabled", parameterName: "respondableReviewsFilter", value: "true" },
    {name: "Only Reviews with a Response Pending Approval", parameterName: "approvableResponseFilter", value: "true" },
    {name: "Only Reviews with New Non-Business Response", parameterName: "customerResponseFilter", value: true}

  ].map(x => {
    return {...x, tag: x.parameterName + ":" + x.value}
  })),

  REPORT_RANGES = [
    {
      id: 'AllTime',
      name: "All Time"
    },
    {
      id: 'Last7Days',
      name: "Last 7 Days"
    },
    {
      id: 'Last30Days',
      name: "Last 30 Days"
    },
    {
      id: 'Last3Months',
      name: "Last 3 Months"
    },
    {
      id: 'Last6Months',
      name: "Last 6 Months"
    },
    {
      id: 'Last12Months',
      name: "Last 12 Months"
    },
    {
      id: 'SpecificDates',
      name: "Selected Dates"
    }
  ],

  SORT_FIELD_OPTIONS = [
    {name: "Date Created", value: "reviewDate"},
    {name: "Date Updated", value: "lastRevisionDate"},
    {name: "Provider", value: "contentProvider"},
    {name: "Rating", value: "rating"}
  ],

  SORT_ORDER_OPTIONS = [
    {name: "Ascending", value: "ASC"},
    {name: "Descending", value: "DESC"}
  ],

  REVIEWBUILDER_CONTENT_PROVIDERS = [
    "REVIEWBUILDER",
    "SHAREITFORWARD",
    "KELLEYBLUEBOOK",
    "RESIDENTCAPTURE",
    "PATIENTREVIEWS"
  ],

  ALL_RATINGS = [
    {key: "1star", name: "1 star"},
    {key: "2star", name: "2 stars"},
    {key: "3star", name: "3 stars"},
    {key: "4star", name: "4 stars"},
    {key: "5star", name: "5 stars"}
  ],

  RECOMMENDATION_OPTIONS = [
    {key: "recommended", name: "Recommended"},
    {key: "notRecommended", name: "Not Recommended"}
  ];
